import React, {Component} from "react";
import {AutoComplete} from "primereact/autocomplete";
import RemotingService from "../../services/remoting-service/RemotingService";

/**
 * Multi-select CPT search cell for the insurance co-pay rules table.
 *
 * Searches unique CPT codes via api/cpt/codes?code={code}. The endpoint scopes results
 * by the `Countries` request header, which RemotingService injects automatically, so no
 * patient/referral/speciality context is needed here. Because the endpoint returns
 * distinct codes, `cptCode` is the stable key: CPTs already assigned to other rules are
 * passed via `excludeCodes` so a code cannot resolve to two rules.
 */
export default class CoPayCptSelector extends Component {

    state = {
        suggestions: []
    };

    cptSearch = (event) => {
        RemotingService.getRemoteCall(`api/cpt/codes?code=${event.query}`, null, cptCodes => {
            const excludeCodes = this.props.excludeCodes || [];
            const selectedCodes = (this.props.value || []).map(c => c.cptCode);
            const suggestions = (cptCodes || []).filter(cpt =>
                !excludeCodes.includes(cpt.cptCode) && !selectedCodes.includes(cpt.cptCode)
            );
            this.setState({suggestions});
        });
    };

    add = (cpt) => {
        this.props.onCptsChange([...(this.props.value || []), cpt]);
    };

    remove = (cpt) => {
        this.props.onCptsChange((this.props.value || []).filter(c => c.cptCode !== cpt.cptCode));
    };

    render() {
        if (this.props.readOnly) {
            const cpts = this.props.value || [];
            return <span>{cpts.length ? cpts.map(c => c.cptCode).join(", ") : "-"}</span>;
        }

        return (
            <div style={{position: 'relative'}}>
                <AutoComplete placeholder="Search CPT..."
                              minLength={2}
                              multiple
                              field="cptCode"
                              value={this.props.value || []}
                              disabled={this.props.disabled}
                              suggestions={this.state.suggestions}
                              completeMethod={this.cptSearch}
                              onSelect={event => this.add(event.value)}
                              onUnselect={event => this.remove(event.value)}
                              onChange={() => {}}
                              itemTemplate={cpt => <span>{cpt.cptCode} - {cpt.description}</span>}/>
            </div>
        );
    }
}
